// extracted by mini-css-extract-plugin
export default {"box":"Search_box__SK0EF","list":"Search_list__VKqns"};